export default {
  chatWidget: {
    chatWithUs: 'Chatte med oss',
    welcomeTitle: 'Velkommen til Bookivo!',
    welcomeMessage: 'Hvordan kan vi hjelpe deg i dag?',
    continueChat: 'Fortsett chat',
    startConversation: 'Start samtale',
    formTitle: 'Fortell oss mer om deg',
    namePlaceholder: 'Ditt navn',
    emailPlaceholder: 'Din e-post',
    phonePlaceholder: 'Ditt telefonnummer',
    nameRequired: 'Vennligst skriv inn navnet ditt',
    emailRequired: 'Vennligst skriv inn e-posten din',
    emailInvalid: 'Vennligst skriv inn en gyldig e-postadresse',
    phoneRequired: 'Vennligst skriv inn telefonnummeret ditt',
    startChat: 'Start chat',
    chatTitle: 'Kundestøtte-chat',
    chatTitleNoAgent: 'Kobler til...',
    endChat: 'Avslutt chat',
    inputPlaceholder: 'Skriv inn meldingen din...',
    greeting: 'Hei',
    greetingMessage: 'Hvordan kan jeg hjelpe deg i dag?',
    emoji: 'Emoji',
    uploadImage: 'Last opp bilde',
    sending: 'Sender...',
    uploadFailed: 'Opplasting mislyktes, vennligst prøv igjen',
    fileTooLarge: 'Filstørrelsen kan ikke overstige 10 MB',
    invalidFileType: 'Kun bildefiler kan lastes opp',
    sendFailed: 'Melding kunne ikke sendes, vennligst prøv igjen',
    imageSendFailed: 'Bilde kunne ikke sendes, vennligst prøv igjen',
    connectionLost: 'Tilkobling mistet, vennligst lukk og gjenåpne chatten',
    uploading: 'Laster opp bilde...',
    sessionEnded: 'Økten er avsluttet',
    rating: {
      title: 'Takk for at du bruker tjenesten vår. Vurder opplevelsen din!',
      satisfied: 'Fornøyd',
      dissatisfied: 'Misfornøyd',
      placeholder: 'Velkommen til å gi oss forslag',
      submit: 'Send inn vurdering',
      endChat: 'Avslutt chat',
      backToChat: 'Tilbake til chat',
      success: 'Takk for tilbakemeldingen!'
    }
  }
}
